module.exports = __webpack_public_path__ + "static/fishing-217909c6a35963dc04dd41865d55e583.jpg";